import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import ProductDetails from './pages/ProductDetails';
import PublishProduct from './pages/PublishProduct';
import ManageProduct from './pages/ManageProduct';
import YourProducts from './pages/YourProducts';
import EditProfile from './pages/EditProfile';
import Chat from './pages/Chat';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';

// Context
import { AuthProvider } from './context/AuthContext';
import UserDetails from './pages/UserDetails';
import AboutUs from './pages/AboutUs';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/publish-product" element={<PublishProduct />} />
            <Route path="/manage-product/:id" element={<ManageProduct />} />
            <Route path="/your-products" element={<YourProducts />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/chat/:id" element={<Chat />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/admin/users/:id" element={<UserDetails />} />
            <Route path="/about" element={<AboutUs />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;